import { render, staticRenderFns } from "./receive_list.vue?vue&type=template&id=5b983250&scoped=true"
import script from "./receive_list.vue?vue&type=script&lang=js"
export * from "./receive_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b983250",
  null
  
)

export default component.exports